// Refined abstract Wave Eleven mark — two flowing strokes suggesting movement.
export function WaveMark({ className = "", stroke = "currentColor", width = 40 }) {
  return (
    <svg className={className} width={width} height={(width * 30) / 40}
      viewBox="0 0 40 30" fill="none" aria-hidden="true">
      <path d="M3 22 C 9 6, 15 6, 20 16 C 25 26, 31 26, 37 10" stroke={stroke} strokeWidth="2" strokeLinecap="round" />
      <path d="M3 14 C 9 2, 15 2, 20 10" stroke={stroke} strokeWidth="2" strokeLinecap="round" opacity="0.55" />
    </svg>
  );
}
export default WaveMark;
